<script lang="ts">
  import { onMount } from "svelte";
  import "../app.css";
  import "$lib/i18n";
  import CursorOrb from "$lib/components/animations/CursorOrb.svelte";
  import Footer from "$lib/components/layout/Footer.svelte";
  import Navbar from "$lib/components/layout/Navbar.svelte";
  import FloatingSocialBar from "$lib/components/layout/FloatingSocialBar.svelte";
  import ScrollControls from "$lib/components/layout/ScrollControls.svelte";
  import SitePreloader from "$lib/components/animations/SitePreloader.svelte";
  import JsonLd from "$lib/components/seo/JsonLd.svelte";
  import { globalSchemaGraph } from "$lib/config/global-schema";
  import { afterNavigate } from "$app/navigation";
  import { createLenis } from "$lib/animations/lenis";
  import { refreshScrollTriggersAfterFonts, refreshScrollTriggers } from "$lib/animations/gsap";
  import { locale } from "svelte-i18n";
  import { page } from "$app/state";
  import { mediaUrl } from "$lib/utils/media";

  let { children } = $props();
  let lenisRuntime: Awaited<ReturnType<typeof createLenis>> = null;

  $effect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = $locale || "en";
    }
  });

  afterNavigate((navigation) => {
    // Run after SvelteKit and browser history have applied their scroll state.
    if (!navigation.to?.url.hash) {
      requestAnimationFrame(() => {
        lenisRuntime?.lenis.scrollTo(0, { immediate: true });
        window.scrollTo(0, 0);
      });
    }

    setTimeout(() => {
      void refreshScrollTriggers();
    }, 150);
  });

  onMount(() => {
    let active = true;

    const startLenis = () => {
      if (!active || lenisRuntime) return;

      createLenis().then((createdRuntime) => {
        if (!active) {
          createdRuntime?.destroy();
          return;
        }
        lenisRuntime = createdRuntime;
        void refreshScrollTriggersAfterFonts();
      });
    };

    const preloader = document.querySelector(".site-preloader");
    if (preloader) {
      window.addEventListener("site-preloader-complete", startLenis, {
        once: true,
      });
    } else {
      startLenis();
    }

    return () => {
      active = false;
      window.removeEventListener("site-preloader-complete", startLenis);
      lenisRuntime?.destroy();
    };
  });
</script>

<svelte:head>
  <link rel="icon" href={mediaUrl("/images/brand/schl-logo.png")} />
  {#if page.url.pathname !== "/"}
    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=IBM+Plex+Mono:wght@400;500&display=swap" />
  {/if}
</svelte:head>

<JsonLd data={globalSchemaGraph} />

<a
  href="#main-content"
  class="sr-only fixed left-4 top-4 z-[60] bg-brand-light px-4 py-3 focus:not-sr-only"
  >Skip to content</a
>
<SitePreloader />
<Navbar />
<FloatingSocialBar />
<ScrollControls />
<CursorOrb />
{@render children()}
<Footer />
